module.exports = __webpack_public_path__ + "img/icon_contact_logo_1690.3842ad23.png";